import Decimal from 'decimal.js';

export function toDecimal(value: string | number | null | undefined) {
  if (value == null || value === '' || typeof value === 'undefined') {
    return Decimal(0);
  }

  if (typeof value === 'number' && isNaN(value)) {
    return Decimal(0);
  }

  const normalized = value.toString()
    .replace(/\s/g, '')   // remove spaces
    .replace(',', '.');   // comma -> dot

  return new Decimal(normalized);
}

export function toFiniteDecimal(value: string | number | null | undefined): Decimal | null {
  if (value == null || String(value).trim() === '' || (typeof value === 'number' && !Number.isFinite(value))) {
    return null;
  }

  try {
    const decimal = toDecimal(value);
    return decimal.isFinite() ? decimal : null;
  } catch {
    return null;
  }
}

// Keep Number's empty/missing-value behavior so request field guards still decide
// whether a value is zero, null, or omitted. Validation handles malformed inputs.
export const toNumber = (value: unknown): number =>
  Number(typeof value === 'string' ? value.replace(',', '.') : value);

export const parseNumber = (value: string | number | null | undefined): number => toNumber(value ?? 0);
